import { PropsWithChildren } from 'react'
import clsx from 'clsx'

import styles from './CompanyTag.module.scss'

type CompanyTagProps = PropsWithChildren<{
  className?: string
}>

/** Marks something as company related, in the brand's company accent */
export default function CompanyTag({ children, className }: CompanyTagProps) {
  return <span className={clsx(styles.tag, className)}>{children}</span>
}
